<script>
  // import { fly } from 'svelte/transition';
  import { tweened } from "svelte/motion";
  import { cubicOut } from "svelte/easing";
  import { onMount } from "svelte";
  import Icon from "svelte-awesome";
  // import {faEdit} from '@fortawesome/free-regular-svg-icons';
  import { faCheck, faPen } from "@fortawesome/free-solid-svg-icons";
  import { navigateTo } from "svelte-router-spa";

  import ProductEdit from "../../edit/Product_Edit.svelte";
  import FeatureGroupsEdit from "../../edit/FeatureGroups_Edit.svelte";
  import BuyerPersonaEdit from "../../edit/BuyerPersona_Edit.svelte";
  import BenefitsEdit from "../../edit/Benefits_Edit.svelte";
  import CompetitorsEdit from "../../edit/Competitors_Edit.svelte";

  import {
    productCreate,
    productEdit,
    featureCreate,
    featureEdit,
    personaEdit,
    benefitEdit,
    benefitCreate
  } from "../../helper/PostHelper.js";

  import Button from "../../components/ui/Button.svelte";
  import Card from "../../components/ui/Card.svelte";
  let buyerPersonaId = null;
  let product = {
    id: null,
    document: {
      mainType: 1,
      subType: 1,
      category: null,
      name: null,
      website: null,
      logo: null,
      colorScheme: null,
      brandrApi: null,
      mainColor: null
    },
    featureGroups: [
      {
        name: "My First Feature",
        value: 0,
        sortPos: 0,
        editMode: true,
        image: null,
        description: `Describe the main characteristics of your product in order of importance.`,
        items: [
          { text: "First Feature", sortPos: 0, value: 0 },
          { text: null, sortPos: 1, value: 1 },
          { text: null, sortPos: 2, value: 2 },
          { text: null, sortPos: 3, value: 3 },
          { text: null, sortPos: 4, value: 4 }
        ]
      }
    ],
    buyerPersona: {
      targetMarketSegment: null,
      roles: null,
      education: [0, 1],
      offer: [],
      pjg: {
        pains: {
          name: "Pains",
          description: "What is your client struggling with in his daily life?",
          items: [
            { text: "First Pain", sortPos: 0, value: 0 },
            { text: null, sortPos: 1, value: 1 },
            { text: null, sortPos: 2, value: 2 },
            { text: null, sortPos: 3, value: 3 },
            { text: null, sortPos: 4, value: 4 }
          ]
        },
        jobs: {
          name: "Jobs",
          description: "What is your client struggling with in his daily life?",
          items: [
            { text: "First Job", sortPos: 0, value: 0 },
            { text: null, sortPos: 1, value: 1 },
            { text: null, sortPos: 2, value: 2 },
            { text: null, sortPos: 3, value: 3 },
            { text: null, sortPos: 4, value: 4 }
          ]
        },
        gains: {
          name: "Gains",
          description: "What is your client struggling with in his daily life?",
          items: [
            { text: "First Gain", sortPos: 0, value: 0 },
            { text: null, sortPos: 1, value: 1 },
            { text: null, sortPos: 2, value: 2 },
            { text: null, sortPos: 3, value: 3 },
            { text: null, sortPos: 4, value: 4 }
          ]
        }
      }
    },
    competitors: [
      {
        url: null,
        screenshots: []
      }
    ],
    benefits: {
      items: [
        // {text: null, sortPos: 0, value: 0},
        // {text: null, sortPos: 1, value: 1},
        // {text: null, sortPos: 2, value: 2},
        // {text: null, sortPos: 3, value: 3},
        // {text: null, sortPos: 4, value: 4}
      ]
    }
  };

  let activeStep = 0;
  let steps = [
    {
      name: "Product",
      modelKey: "document",
      comp: ProductEdit,
      action: "productEdit"
    },
    {
      name: "Features",
      modelKey: "featureGroups",
      comp: FeatureGroupsEdit,
      action: "featureEdit"
    },
    {
      name: "Buyer Persona",
      modelKey: "buyerPersona",
      comp: BuyerPersonaEdit,
      action: "personaEdit"
    },
    {
      name: "Competitors",
      modelKey: "competitors",
      comp: CompetitorsEdit,
      action: "competitorEdit"
    },
    { name: "Benefits", modelKey: null, comp: BenefitsEdit }
  ];
  let waiting = false;

  function handleSubmit() {
    waiting = true;
    console.log(product);
    benefitCreate(product, buyerPersonaId)
      .then(result => {
        setTimeout(() => {
          navigateTo("/");
        }, 500); //TODO wait till the file is actually there and go to ist overview
      })
      .catch(err => {
        console.log(err);
        alert(`Error ${err}`);
        waiting = false;
      });
  }

  const progress = tweened(0, {
    duration: 400,
    easing: cubicOut
  });

  const nextStep = function() {
    switch (steps[activeStep].action) {
      case "productEdit":
        if (product.id == null) {
          productCreate(product.document).then(res => {
            product.id = res.id;
          });
        } else productEdit(product.document);
        break;
      case "featureEdit":
        featureCreate(product).then(res => {
          // product.featureGroups = res;
          console.log(res);
        });
        break;
      case "personaEdit":
        personaEdit(product).then(res => {
         // product.buyerPersona = res.data;
          buyerPersonaId = res.buyerPersonaId;
        });
        break;
    }
    activeStep += 1;
    progress.set((100 / steps.length) * (activeStep + 1));
  };

  const back = function() {
    activeStep -= 1;
    progress.set((100 / steps.length) * (activeStep + 1));
  };

  function goToStep(index) {
    activeStep = index;
    progress.set((100 / steps.length) * (index + 1));
  }

  onMount(() => {
    progress.set((100 / steps.length) * (activeStep + 1));
  });
</script>

<div>
  <form on:submit|preventDefault={handleSubmit} class="p-4">
    <div>
      <div class="w-full relative bg-gray-200">
        <div class="bg-gray-700 h-12" style="width:{$progress}%" />
        <div class="absolute left-0 w-full" style="top:6px">
          {#each steps as step, i}
            <button
              on:click|preventDefault={() => goToStep(i)}
              class="w-1/{steps.length} focus:outline-none focus:shadow-outline"
              class:text-white={activeStep >= i}>
              <div
                class="p-2 rounded-full bg-gray-700 text-white inline-block"
                style="height:36px; width:36px;line-height:20px;"
                class:bg-main={activeStep >= i}>
                {#if activeStep > i}
                  <Icon data={faCheck} />
                {:else if activeStep == i}
                  <Icon data={faPen} />
                {:else}{i + 1}{/if}
              </div>
              <span>{step.name}</span>
            </button>
          {/each}
        </div>
      </div>
      {#each steps as step, i}
        {#if activeStep == i}
          <div>
            {#if step.modelKey != null}
              <svelte:component
                this={step.comp}
                bind:model={product[step.modelKey]} />
            {:else}
              <svelte:component this={step.comp} bind:model={product} />
            {/if}
          </div>
        {/if}
      {/each}
    </div>
    <div class="flex flex-row">
      <span class="flex-grow" />
      {#if activeStep > 0}
        <Button on:submit={back}>Back</Button>
      {/if}
      {#if activeStep < steps.length - 1}
        <Button on:submit={nextStep} raised={true} primary={true}>Next</Button>
      {/if}
      {#if activeStep == steps.length - 1}
        <Button type="submit" raised={true} primary={true}>Submit</Button>
      {/if}
    </div>
  </form>
</div>
